<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
       LCA Preparer
    </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="p-4">
        <form [formGroup]="lcaPreparer">
            
        
        <div class="row">
            <h5 class="col-md-8 labelText"> LCA Preparer </h5>      
            <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                <button class="clear-data-button" (click)="clearData()">
                    <i class="fa fa-repeat"></i> Clear Data
                 </button>
            </div>
        </div>
        
        <div class="row mt-2">
            <!-- First Name -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">First Name (Given)</label>
                <input class="im-input"
                        name="firstName"
                        formControlName="firstName"
                        type="text"
                        placeholder="Enter"/>
                        <span class="invalid-message" 
                        *ngIf="(lcaPreparer.get('firstName').touched  && lcaPreparer.get('firstName').invalid)">
                {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>
            <!-- Middle Name -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Middle Name</label>
                <input class="im-input"
                        type="text"
                        name="middleName"
                        formControlName="middleName"
                        placeholder="Enter"/>
                        <span class="invalid-message" 
                        *ngIf="(lcaPreparer.get('middleName').touched  && lcaPreparer.get('middleName').invalid)">
                {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>
            <!-- Last Name (Family Name) -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Last Name (Family Name)</label>
                <input class="im-input"
                        type="text"
                        name="lastName"
                        formControlName="lastName"
                        placeholder="Enter" />
                        <span class="invalid-message" 
                        *ngIf="(lcaPreparer.get('lastName').touched  && lcaPreparer.get('lastName').invalid)">
                {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>
        </div> 
  
        <div  class="row mt-2">
            <!-- Address 1 -->
            <div class="form-group col-md-6">
                <label class="control-lbl  label-cls">Firm/Business Name</label>
                <input class="im-input"
                   name="firmName"
                   formControlName="firmName"
                        type="text"                      
                        placeholder="Enter" />
                        <span class="invalid-message" 
                        *ngIf="(lcaPreparer.get('firmName').touched  && lcaPreparer.get('firmName').invalid)">
                {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>

            <div class="form-group col-md-4"> 
                <label class="label-cls">Email ID</label>
                <input class="im-input"
                        type="email"
                        name="emailId"
                        formControlName="emailId"
                        placeholder="Enter" />    
                        <span class="invalid-message" 
                        *ngIf="(lcaPreparer.get('emailId').touched  && lcaPreparer.get('emailId').invalid)">
                        {{ getGlobalErrorMessages("INVALID_EMAIL") }}
                </span>        
                    </div>
        </div>
  </form>
</div>
<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>  
